"use client"

import Link from "@/components/ui/intent-link"
import { Button } from "@/components/ui/button"
import { useLogger } from "@/lib/hooks/use-logger"

export function FooterDownloadButton() {
  const logger = useLogger()

  const handleClick = () => {
    logger.info("download_click", {
      event: "download_click",
      funnel_step: "download_click",
      source: "footer",
    })
    window.gtag?.("event", "download_click", { source: "footer" })
  }

  return (
    <Button
      asChild
      className="text-white gap-2 text-sm font-medium h-10 bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 w-fit border-0"
    >
      <Link href="/download" onClick={handleClick}>
        Download
      </Link>
    </Button>
  )
}
